var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "slide-nav",
    "class": [_vm.containerClass, _vm.contentPosition]
  }, [_c('div', {
    staticClass: "slide-nav-item-wrap",
    "class": [_vm.wrapClass]
  }, [_vm._l(_vm.navigations, function (navigation, index) {
    return _c('div', {
      key: index,
      ref: navigation.value,
      refInFor: true,
      staticClass: "slide-nav-item",
      "class": {
        selected: _vm.value == navigation.value,
        itemClass: true,
        'first-font-color': navigation.nickname
      },
      attrs: {
        "id": navigation.value
      },
      on: {
        "click": function click($event) {
          return _vm.onClick(navigation.value);
        }
      }
    }, [_vm._t(navigation.value, function () {
      return [_c('div', {
        staticClass: "slide-item-text"
      }, [_vm._v(_vm._s(navigation.text))]), navigation.text1 ? _c('div', {
        staticClass: "slide-item-nickname"
      }, [_vm._v(_vm._s(navigation.text1))]) : _vm._e()];
    })], 2);
  }), _vm.indicatorVisible && _vm.navigations && _vm.navigations.length > 0 && _vm.value != null && _vm.value != '' ? _c('div', {
    staticClass: "slide-nav-indicator",
    "class": [_vm.indicatorClass],
    style: {
      left: (_vm.selectedIndex + 0.5) * _vm.percentage + '%'
    }
  }) : _vm._e()], 2)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };